import baseApi from "./baseApi";
import axios from "axios";



const getTickets = () => axios.get("CRM/Tickets", { headers: { 'Authorization': 'Bearer ' + baseApi.getToken() } });
const getTicket = (r) => axios.get("CRM/Ticket/" + r, { headers: { 'Authorization': 'Bearer ' + baseApi.getToken() } });
// const sendTicketMessage = (r) => axios.put(`CRM/Ticket/`, r, { headers: { 'Authorization': 'Bearer ' + baseApi.getToken() } });
// const sendTicket = (r) => axios.post(`CRM/Ticket/`, r, { headers: { 'Authorization': 'Bearer ' + baseApi.getToken() } });
const sendRequest = (r) => axios.post(`CRM/Request/`, r, { headers: { 'Authorization': 'Bearer ' + baseApi.getToken() } });


const sendTicketMessage = (r, onUploadProgress) => {
    return axios.put(`CRM/Ticket/`, r, {
        headers: { 'Authorization': 'Bearer ' + baseApi.getToken() },
        onUploadProgress: onUploadProgress 
    });
};

const sendTicket = (r, onUploadProgress) =>{
    return axios.post(`CRM/Ticket/`, r, { 
        headers: { 'Authorization': 'Bearer ' + baseApi.getToken() },
        onUploadProgress: onUploadProgress 
    });
};

export default {
    getTickets,
    getTicket,
    sendTicketMessage,
    sendTicket,
    sendRequest
};